export default __webpack_public_path__ + "static/media/rakhi6.659c3819.jpeg";